import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface IChangePasswordRequest{
  password: string,
  newPassword: string,
  confirmNewPassword: string
}

@Injectable({
  providedIn: 'root'
})
export class PersonalService {

  constructor(private http: HttpClient) {}

  getPermissionOfCurrentUser(){
    return this.http.get<string[]>(
      `${environment.baseUrl}/personal/permissions`
    )
  }

  changePassword(request: IChangePasswordRequest){
    return this.http.put<string>(
      `${environment.baseUrl}/personal/change-password`,
      request
    )
  }

}
